import axios from "axios";
import { AxiosResponse, AxiosError } from "axios";
import { validateCommerceSession } from "../../utils/validateCommerceSession";
import { getLanguage } from "./accessToken";

/**
 * API call to fetch product details
 */
export async function fetchProductDetails(productCode: any) {
  await validateCommerceSession();

  const tokens = JSON.parse(
    localStorage.getItem("commerce_token_storage") || "{}"
  );

  const userInfo = localStorage.getObj("user-info");
  const idToken = tokens?.idToken;
  const accessToken = tokens?.accessToken?.access_token;

  const isAnonymous =
    !userInfo?.partyId || userInfo?.partyId === "anonymous";

  const userPath = isAnonymous ? "anonymous" : userInfo.partyId;

  const config = {
    method: "get" as const,
    url: `${process.env.REACT_APP_PRODUCT_DETAILS_URL}/v2/${
      process.env.REACT_APP_BASE_SITE_ID
    }/users/${userPath}/products/${productCode}?lang=${getLanguage()}`,
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...(idToken?.id_token ? { id_token: idToken.id_token } : {}),
    },
  };

  return axios(config)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
      console.error("fetchProductDetails error", error);
      return error.response?.status;
    });
}

/**
 * API call to fetch product review detail
 */
export async function fetchProductReview(id: any) {
  await validateCommerceSession();

  let config: any = {
    method: "get",
    // url: `${process.env.REACT_APP_PRODUCT_REVIEW_URL}?passkey=${
    //   process.env.REACT_APP_PRODUCT_REVIEW_PASS_KEY
    // }&apiversion=5.4&stats=Reviews&filter=productid:${id}`,
    url: `${process.env.REACT_APP_PRODUCT_REVIEW_URL}?passkey=${process.env.REACT_APP_PRODUCT_REVIEW_PASS_KEY}&apiversion=5.4&stats=Reviews&filter=productid:${id}`,
  };

  return axios(config)
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {});
}
